import {
  get as apiGet,
  post as apiPost,
  patch as apiPatch,
  del as apiDel,
  mock,
  isRealApiEnabled,
} from "./client";
import adminCartMock from "./mocks/adminCart";

function recalc(cart) {
  const subtotalCents = cart.items.reduce(
    (sum, it) => sum + it.unitPriceCents * it.quantity,
    0
  );
  return { ...cart, subtotalCents, updatedAt: new Date().toISOString() };
}

/**
 * @endpoint GET /api/v1/admin/cart
 * @returns {Promise<AdminCart>}
 */
export function get() {
  if (isRealApiEnabled()) return apiGet("/v1/admin/cart");
  return mock(adminCartMock);
}

/**
 * @endpoint POST /api/v1/admin/cart/items
 * @returns {Promise<AdminCart>}
 */
export function addItem(item) {
  if (isRealApiEnabled()) {
    return apiPost("/v1/admin/cart/items", item);
  }
  const next = {
    ...adminCartMock,
    items: [
      ...adminCartMock.items,
      {
        id: `ci_new_${Date.now()}`,
        variationId: null,
        quantity: 1,
        unitPriceCents: 0,
        ...item,
      },
    ],
  };
  return mock(recalc(next));
}

/**
 * @endpoint PATCH /api/v1/admin/cart/items/:itemId
 * @returns {Promise<AdminCart>}
 */
export function updateItem(itemId, patch) {
  if (isRealApiEnabled()) {
    return apiPatch(`/v1/admin/cart/items/${itemId}`, patch);
  }
  const next = {
    ...adminCartMock,
    items: adminCartMock.items.map((it) =>
      it.id === itemId ? { ...it, ...patch } : it
    ),
  };
  return mock(recalc(next));
}

/**
 * @endpoint DELETE /api/v1/admin/cart/items/:itemId
 * @returns {Promise<AdminCart>}
 */
export function removeItem(itemId) {
  if (isRealApiEnabled()) {
    return apiDel(`/v1/admin/cart/items/${itemId}`);
  }
  const next = {
    ...adminCartMock,
    items: adminCartMock.items.filter((it) => it.id !== itemId),
  };
  return mock(recalc(next));
}

/**
 * @endpoint DELETE /api/v1/admin/cart
 * @returns {Promise<AdminCart>}
 */
export function clear() {
  if (isRealApiEnabled()) {
    return apiDel("/v1/admin/cart");
  }
  return mock(recalc({ ...adminCartMock, items: [] }));
}
